import { Box } from "@mui/material";
import Titre from "../../component/titre/titre";

export default function PiePage(){

    return (
        <Box margin="20px">
            <Box display="flex" justifyContent="Space-between">
                <Titre title="Pie chart" subtitle="stat with line Chart"/> 
                
            </Box>
        </Box>
    )
}  